/*
		browser.js,
			Browser detection stuff.
 */


var Browser = module.exports = {
	isIE: navigator.appName.toLowerCase().indexOf("microsoft") != -1,
	isIEPre9: navigator.appName.toLowerCase().indexOf("microsoft") != -1 && (typeof document.documentElement.style.opacity == 'undefined'),
	isIE9: navigator.appName.toLowerCase().indexOf("microsoft") != -1 && (typeof document.documentElement.style.opacity != 'undefined'),
	isIE6: navigator.appName.toLowerCase().indexOf("microsoft") != -1 && ! window.XMLHttpRequest,
	isIE7: navigator.appVersion.indexOf("MSIE 7.") != -1,
	isIE8: navigator.appVersion.indexOf("MSIE 8.") != -1,
	isFirefox: (navigator.userAgent.toLowerCase().indexOf("firefox") != -1 || navigator.userAgent.toLowerCase().indexOf("Namoroka") != -1),
	isGecko: navigator.product == 'Gecko',
	isSafari: navigator.vendor && navigator.vendor.toLowerCase().indexOf('apple') != -1,
	isWebKit: navigator.userAgent.toLowerCase().indexOf("khtml") != -1,
	isTouchPhone: (navigator.userAgent.toLowerCase().indexOf("android") != -1 || navigator.userAgent.toLowerCase().indexOf("iphone") != -1)
}

